module.exports = __webpack_public_path__ + "static/media/cgs_logo_vertical.d71f386f.png";